module.exports = __webpack_public_path__ + "static/media/small_heart@2x.f9b0da47.png";